// SocialMediaIcon.jsx
// TK 03/21/2k22

// Packages, Dependencies, and Shared Libraries
import React from "react";
import { openInNewTab } from "../sharedFunctions";

/*******************************************************************************
 * @func SocialMediaIcon (React Component)
 * Contains an image that when clicked, takes the user to the social media page
 * in a separate window
 * @param logoRelPath (string): Relative path to the image to be displayed
 * @param link (string): Link to the social media page
 *
 * @notes None
 *
 ******************************************************************************/
const SocialMediaIcon = ({ logoRelPath, link }) => {
  return (
    <div
      className="flex items-center justify-center shrink-0"
      style={{ width: "min(36px, 8vw)", height: "min(36px, 8vw)" }}
    >
      <img
        className="cursor-pointer hover:opacity-70 transition-opacity max-w-full max-h-full"
        src={logoRelPath}
        alt={link}
        onClick={() => openInNewTab(link)}
      />
    </div>
  );
}; // End SocialMediaIcon

export default SocialMediaIcon;
